export const LIST_TYPES = [
  'ordered-list',
  'unordered-list'
]
